import store from '@/store';
import CalculateFMCService from '@/services/DataProcess/CalculateFMCService'
import { ParsePeriodicalResult } from './utils'

import communicationService from '@/services/PostMessageCommunation/CommunicationService';
import dataKeys from '@/services/PostMessageCommunation/enums/DataKeys';

import { getTranslationPop } from '@/services/Base/TranslationUtils';

const DataWatcherService = {
  isRunning: false,
  unwatchers: [],

  init() {
    if (!store.state.kit.deepAncestryCoordinate) {
      return;
    }
    const resolveSource = CalculateFMCService.codeDataToArray(store.state.kit.deepAncestryCoordinate);
    if (resolveSource.isSuccess) {
      CalculateFMCService.onSetTarget(resolveSource.result);
    }

    this.watchPeriodState();
    this.watchRegionState();
    this.watchShowAllEraState();

    this.runPeriodicalResult();
  },

  watchPeriodState() {
    const unwatch = store.watch(
      (state) => state.period.selectedPeriod,
      (newValue, oldValue) => {
        if (newValue !== oldValue) {
          this.runPeriodicalResult();
        }
      }
    );

    this.unwatchers.push(unwatch);
  },

  watchRegionState() {
    const unwatch = store.watch(
      (state) => state.region.selectedRegion,
      (newValue, oldValue) => {
        if (newValue !== oldValue) {
          this.runPeriodicalResult();
        }
      }
    );

    this.unwatchers.push(unwatch);
  },

  watchShowAllEraState() {
    const unwatch = store.watch(
      (state) => state.periodicalResult.showAllEra,
      (newValue, oldValue) => {
        if (newValue !== oldValue) {
          this.runPeriodicalResult();
        }
      }
    );

    this.unwatchers.push(unwatch);
  },

  async runPeriodicalResult() {
    try {
      if (!(store.state.region.selectedRegion && store.state.period.selectedPeriod)) {
        return;
      }
      
      if (this.isRunning) {
        return;
      }
      this.isRunning = true;

      store.commit('periodicalResult/setUiResults', null);
      const sourceDataRequest = {
        regionId: store.state.region.selectedRegion.id,
        periodId: store.state.period.selectedPeriod.id,
      };

      const sourceDataResult = await store.dispatch('periodSourceData/fetchPeriodSourceData', sourceDataRequest);
      if (!sourceDataResult) {
        this.isRunning = false;
        return;
      }
      
      const resolveSource = CalculateFMCService.codeDataToArray(sourceDataResult.sourceData);
    
      if (resolveSource.isSuccess) {
        CalculateFMCService.onSetSource(resolveSource.result);
      }

      const calculatedResult = await this.getCurrentResult(sourceDataRequest, sourceDataResult.version, store.state.region.selectedRegion);
     
      const parsedCalculatedResult = store.state.periodicalResult.showAllEra ? ParsePeriodicalResult(calculatedResult, resolveSource.result) : ParsePeriodicalResult(calculatedResult);
  
      store.commit('periodicalResult/setOriginalResults', parsedCalculatedResult.originalResults);
      store.commit('periodicalResult/setGroupedResults', parsedCalculatedResult.groupedResults);

      const groupedResults = parsedCalculatedResult.groupedResults;
      const groupedSourceCodes = groupedResults.resultList.map(item => item.resultName);
      const uiDetailDataResult = await store.dispatch('periodicalResult/fetchSupervisedPeriodDetails', groupedSourceCodes);
      if (!uiDetailDataResult) {
        this.isRunning = false;
        return;
      }
      
      uiDetailDataResult.forEach(geoItem => {
        /* eslint-disable */
        let isFoundData = false;
        geoItem.title = 'Map Title Not Found';

        groupedResults.resultList.forEach(resultItem => {
          resultItem.title = getTranslationPop(store, resultItem.resultName, 'title', resultItem.resultName.replaceAll('*', ' '));
          if (resultItem.resultName === geoItem.sourceCode) {
            resultItem.id = geoItem.id;
            resultItem.sourceCode = geoItem.sourceCode;
            resultItem.color = geoItem.color;
            resultItem.logoUrl = geoItem.logoUrl;
            resultItem.description = geoItem.description;

            geoItem.title = resultItem.title;
            geoItem.ancestryValue = resultItem.resultValue.toFixed(1);

            isFoundData = true;
          }
        });

        if (isFoundData === false) {
          geoItem.ancestryValue = 0;
          geoItem.color = '#b8b8b8';
        }
      });
      
      store.commit('periodicalResult/setGeoJson', uiDetailDataResult);
      store.commit('periodicalResult/setUiResults', groupedResults);
      
      this.isRunning = false;
    } catch (error) {
      this.isRunning = false;
      console.error('Error handling specific state change:', error);
    }
  },

  async getCurrentResult(params, sourceDataVersion, region) {
    let resultData = null;

    try {
      const requestParams = {
        region_id: params.regionId,
        period_id: params.periodId,
        kit_id: '',
      };
  
      const response = await communicationService.requestData({ key: dataKeys.GET_PERIODICAL_RESULT, value: requestParams});
      
      if(response.version !== sourceDataVersion || !response.result_data) {
        // if(region.guid === '81b2bed1-f2ac-4bc6-b597-7ed87fa4cd26' ||
        //   region.guid === '438e98b2-4ce9-4cc1-9155-f37e910eb2d4') {
        //     CalculateFMCService.dataObject.addDistCol = 2;
        // }
        
        response.result_data = CalculateFMCService.runABAlgorithm();
        communicationService.sendDataToParent({ 
          key: dataKeys.SAVE_PERIODICAL_RESULT, 
          value: { params: requestParams, result_data: JSON.stringify(response.result_data), version: sourceDataVersion }
        });
        resultData = response.result_data;
      } else {
        resultData = JSON.parse(response.result_data);
      }
    } catch (error) {
      console.error('getCurrentResult:', error);
    }

    // CalculateFMCService.dataObject.addDistCol = 1;

    return resultData;
  },

  cleanup() {
    this.unwatchers.forEach(unwatch => unwatch());
    this.unwatchers = [];
    
    this.isRunning = false;
  },
};

export default DataWatcherService;
